import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Wordmark } from './Brand';
import { CookieChoicesDialog } from './consent/CookieChoicesDialog';
import { APP_STATUS, OPERATOR_NAME, SUPPORT_EMAIL } from '../lib/links';
import { pricing } from '../lib/pricing';
const footerLinks = [{
  to: '/worlds',
  label: 'Worlds'
}, {
  to: '/parents',
  label: 'For parents'
}, {
  to: '/pricing',
  label: 'Pricing'
}, {
  to: '/support',
  label: 'Support'
}, {
  to: '/privacy',
  label: 'Privacy'
}, {
  to: '/terms',
  label: 'Terms'
}];
export function Footer() {
  const [cookieDialogOpen, setCookieDialogOpen] = useState(false);
  return <footer className="border-t border-ink/10 bg-lavender" data-id="element-127" data-mp="3ldu8l5f6f825">
      <div className="mx-auto max-w-content px-5 py-10 sm:px-6" data-id="element-128" data-mp="3qcnkiteter07">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between" data-id="element-129" data-mp="3qf9nsguoakcm">
          <div className="max-w-sm" data-id="element-130" data-mp="2a1jlnfn4665m">
            <Link to="/" aria-label="Lightning Learn, home" className="inline-block rounded-xl" data-id="element-131" data-mp="2eyjqxoc534vo">
              <Wordmark decorative className="-ml-2 h-[72px] w-[108px]" data-id="element-132" data-mp="3l8qv40rs6dpv" />
            </Link>
            <p className="mt-2 text-[16px] text-ink/80" data-id="element-133" data-mp="3gaz2f4jbankm">
              Illustrated learning adventures for curious kids {pricing.ageLabel}. {APP_STATUS}.
            </p>
          </div>

          <nav aria-label="Footer" className="md:pt-4" data-id="element-134" data-mp="3q8wqns168kd8">
            <ul className="grid grid-cols-2 gap-x-12 gap-y-3 sm:grid-cols-3" data-id="element-135" data-mp="3q7282kddh4cb">
              {footerLinks.map(link => <li key={link.to} data-id="element-136" data-mp="80ntqkb6ysde">
                  <Link to={link.to} className="whitespace-nowrap text-[16px] font-semibold text-ink/80 transition-colors duration-150 ease-out hover:text-ink" data-id="element-137" data-mp="34p9n8wwbwis">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>

        <div className="mt-8 flex flex-col gap-2 border-t border-ink/15 pt-6 text-[15px] text-ink/80 sm:flex-row sm:items-center sm:justify-between" data-id="element-138" data-mp="qr5ikdswl3th">
          <p data-id="element-139" data-mp="tw5yw7u65sn9">
            © {new Date().getFullYear()} {OPERATOR_NAME}. Lightning Learn is operated by {OPERATOR_NAME}.
          </p>
          <div className="flex flex-wrap items-center gap-x-6" data-id="element-140" data-mp="yuhaoo40yd84">
            <button type="button" onClick={() => setCookieDialogOpen(true)} aria-haspopup="dialog" className="min-h-[44px] font-semibold underline decoration-ink/30 underline-offset-4 transition-colors duration-150 ease-out hover:text-ink" data-id="element-141" data-mp="13s9980z6cxla">
              Cookie choices
            </button>
            <a href={`mailto:${SUPPORT_EMAIL}`} className="inline-flex min-h-[44px] items-center font-semibold transition-colors duration-150 ease-out hover:text-ink" data-id="element-142" data-mp="1mjsbg5ldk7m9">
              {SUPPORT_EMAIL}
            </a>
          </div>
        </div>
      </div>
      <CookieChoicesDialog open={cookieDialogOpen} onClose={() => setCookieDialogOpen(false)} data-id="element-143" data-mp="3ta8a3ixvgzaz" />
    </footer>;
}